import { Action } from '@ngrx/store';
import { IOrderModel, SortingProperty, TimePeriodsFilters } from '../../models/account/IOrderModel';
// import {ExpandOrderPayload} from "../../components/orders-page/orders-page.component";    //TODO <orders-page.component> ???
import { Sorting } from '../../models/account/sortingTypes.model';

// export const GET_ORDERS_CONFIG            = '[ORDERS] Get Orders config';
// export const GET_ORDERS_CONFIG_SUCCESS    = '[ORDERS] Get Orders config success';

export const GET_ORDERS = '[ORDERS] Get Orders';
export const GET_ORDERS_SUCCESS = '[ORDERS] Get Orders Success';
export const GET_ORDERS_ERROR = '[ORDERS] Get Orders Error';
export const FILTER_ORDERS_BY_DATE = '[ORDERS] Filter Orders by Date';
export const FILTER_ORDERS_BY_DATE_SUCCESS = '[ORDERS] Filter Orders by Date success';
export const FILTER_ORDERS_BY_OFFICE_CODE = '[ORDERS] Filter Orders by Office Code';
export const FILTER_ORDERS_BY_OFFICE_CODE_SUCCESS = 'Filter Orders by Office Code success';
export const EXPAND_ORDER_ITEMS = '[ORDERS] Expand Order Items';

export const SORT_ORDERS_BY_PROPERTY = '[ORDERS] Sort Orders by Property';
export const SORT_ORDERS_BY_PROPERTY_SUCCESS = '[ORDERS] Sort Orders by Property SUCCESS';

export const SEARCH_ORDERS = '[ORDERS] Search Orders by Order Number or Product name';
export const CHANGE_PAGE = '[ORDERS] Change Page';

// //Actions for Getting Orders
// export class GetOrdersConfig implements Action {
//   readonly type = GET_ORDERS_CONFIG;
// }
//
// export class GetOrdersConfigSuccess implements Action {
//   readonly type = GET_ORDERS_CONFIG_SUCCESS;
//
//   constructor(public payload: I_OrderConfig) {
//   }
// }

export class GetOrders implements Action {
  readonly type = GET_ORDERS;
}

export class GetOrdersSuccess implements Action {
  readonly type = GET_ORDERS_SUCCESS;

  constructor(public payload: OrdersPayload) {}
}

export class ExpandOrderItems implements Action {
  // constructor(public payload: ExpandOrderPayload) { }
  readonly type = EXPAND_ORDER_ITEMS;

  constructor(public payload: any) {}
}

export class FilterOrdersByDate implements Action {
  readonly type = FILTER_ORDERS_BY_DATE;
  constructor(public payload: TimePeriodsFilters) {}
}

export class FilterOrdersByDateSuccess implements Action {
  readonly type = FILTER_ORDERS_BY_DATE_SUCCESS;
  constructor(public payload: OrdersPayload) {}
}

export class FilterOrdersByOfficeCode implements Action {
  readonly type = FILTER_ORDERS_BY_OFFICE_CODE;
  constructor(public payload: string) {}
}

export class FilterOrdersByOfficeCodeSuccess implements Action {
  readonly type = FILTER_ORDERS_BY_DATE_SUCCESS;
  constructor(public payload: OrdersPayload) {}
}

export class SortOrdersByProperty implements Action {
  readonly type = SORT_ORDERS_BY_PROPERTY;
  constructor(public payload: SortingPayload) {}
}
export class SortOrdersByPropertySuccess implements Action {
  readonly type = SORT_ORDERS_BY_PROPERTY_SUCCESS;
  constructor(public payload: IOrderModel[]) {}
}

export class SearchOrders implements Action {
  readonly type = SEARCH_ORDERS;
  constructor(public payload: string) {}
}

export class GetOrdersError implements Action {
  readonly type = GET_ORDERS_ERROR;
}

export class ChangePage implements Action {
  readonly type = CHANGE_PAGE;
  constructor(public payload: number) {}
}

export interface OrdersPayload {
  allOrders: IOrderModel[];
  searchedOrders: IOrderModel[];
  timePeriod: TimePeriodsFilters;
  officesFilter: string;
}

export interface SortingPayload {
  sortingProperty: SortingProperty;
  sorting: Sorting;
}

export type ActionsOrders =
  // GetOrdersConfigSuccess
  // | GetOrdersConfig
  | GetOrders
  | GetOrdersSuccess
  | GetOrdersError
  | SortOrdersByProperty
  | SortOrdersByPropertySuccess
  | ExpandOrderItems
  | FilterOrdersByDate
  | FilterOrdersByDateSuccess
  | FilterOrdersByOfficeCode
  | FilterOrdersByOfficeCodeSuccess
  | SearchOrders
  | ChangePage;
